import { useQuery } from '@tanstack/react-query';
import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import styled from 'styled-components';

import useUser from '@/hooks/useUser';
import { FreelancerVacationBalanceResource } from '@/types/resources';
import { api } from '@/utils/api';

import ApprovalsTable from './components/ApprovalsTable';
import FreelancerProfileCard from './components/FreelancerProfileCard';
import VacationHeader from './components/VacationHeader';

const Grid = styled.div`
  display: grid;
  grid-template-columns: 424px auto;
  grid-gap: 24px;
  margin-top: 80px;
`;

const TablesHolder = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

const RequestVacation = () => {
  const user = useUser();
  const navigate = useNavigate();

  useEffect(() => {
    if (user && !user.freelancer?.id) {
      navigate('/', { replace: true });
    }
  }, [user, navigate]);

  const { isLoading, data: balance } =
    useQuery<FreelancerVacationBalanceResource>(
      ['freelancer_vacation_balance', { id: user?.freelancer?.id }],
      () =>
        api.get<never, FreelancerVacationBalanceResource>(
          `/v1/payments/freelancers/holidays/balance/${user?.freelancer?.id}`,
        ),
      {
        staleTime: 60 * 1000,
        retry: 2,
      },
    );

  if (!user?.freelancer?.id) {
    return null;
  }

  return (
    <>
      <VacationHeader />
      <Grid>
        <FreelancerProfileCard isLoading={isLoading} balance={balance} />
        <TablesHolder>
          <ApprovalsTable isPending />
          <ApprovalsTable />
        </TablesHolder>
      </Grid>
    </>
  );
};

export default RequestVacation;
